


























import { Component, Vue } from 'vue-property-decorator'
import { ExtendedRouteConfig, ExtendedRouter, RouteGroup } from '@/types/routing-types'
import { routeGroupName } from '@/routes'


interface RouterGroup {
    key: RouteGroup;
    name: string;
    routes: ExtendedRouteConfig[];
}


@Component
export default class Home extends Vue {
    /**
     * All routes attached to the instance of this dashboard.
     */
    get routes(): ExtendedRouteConfig[] {
        return (this.$router as ExtendedRouter).options.routes
    }

    /**
     * Organize all routes by listing them out by their group key.
     */
    get groupedRoutes(): { [key in RouteGroup]: ExtendedRouteConfig[] } {
        const groups: { [key in RouteGroup]: ExtendedRouteConfig[] } = {
            [RouteGroup.DEFAULT]: [],
            [RouteGroup.REPORTS]: [],
            [RouteGroup.SOCIAL_MEDIA]: [],
            [RouteGroup.INTEGRATION]: [],
            [RouteGroup.TWM]: [],
            [RouteGroup.EMP_REW]: [],
            [RouteGroup.FRANCHISE_MGMT]: [],
            [RouteGroup.TECH_TEAM]: []
        }
        for (const route of this.routes) {
            if (!groups[route.meta.group]) {
                groups[route.meta.group] = []
            }
            if (route.meta.displayHome) {
                (groups[route.meta.group] as ExtendedRouteConfig[]).push(route)
            }
        }
        return groups
    }

    get groups(): RouterGroup[] {
        const groups: RouterGroup[] = []
        for (const group in routeGroupName) {
            groups.push({
                key: group as unknown as RouteGroup,
                name: routeGroupName[group as unknown as RouteGroup],
                routes: this.groupedRoutes[group as unknown as RouteGroup]
            })
        }
        return groups
    }
}
